import { render, staticRenderFns } from "./tuozhanfenpei.vue?vue&type=template&id=7210fa28&scoped=true&"
import script from "./tuozhanfenpei.vue?vue&type=script&lang=js&"
export * from "./tuozhanfenpei.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/resource/tuozhanfenpei.less?vue&type=style&index=0&id=7210fa28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7210fa28",
  null
  
)

component.options.__file = "tuozhanfenpei.vue"
export default component.exports